import React, { useContext } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import { ErrorLevel } from 'gw-portals-edge-validation-js';
import { messages as commonMessages } from 'gw-platform-translations';
import { WizardContext } from '../WizardContext';
import styles from './WizardSidebar.module.scss';
import { ProgressIndicator, ProgressPhase, ProgressStep } from '@jutro/components';

/**
 * @typedef {import('gw-portals-edge-validation-js/errors').GenericUIIssue} GenericUIIssue
 */

/**
 * Renders an icon for steps with errors
 * @param {Array<GenericUIIssue>} errorsAndWarnings array
 * @returns {Object}
 */
function renderErrors(errorsAndWarnings = []) {
    const highestLevel = errorsAndWarnings
        .map((err) => err.level)
        .reduce((currentHighest, currentError) => {
            if (!currentHighest) {
                return currentError;
            }
            if (currentHighest === ErrorLevel.LEVEL_WARN) {
                // currentError can only Greater or Equal than currentHighest
                return currentError;
            }
            return currentHighest;
        }, null);
    switch (highestLevel) {
        case ErrorLevel.LEVEL_ERROR:
            return <Icon icon="mi-remove_circle_outline" className={styles.errorIssue} />;
        case ErrorLevel.LEVEL_WARN:
            return <Icon icon="mi-warning" className={styles.warningIssue} />;
        default:
            return null;
    }
}

function jumpRenderModal(index, jumpTo, steps, step, wizardContext, customMessageModal) {
    const modalMessages = {
        title: !_.isEmpty(customMessageModal)
            ? customMessageModal.title
            : commonMessages.wantToJump,
        message: !_.isEmpty(customMessageModal)
            ? customMessageModal.message
            : commonMessages.wantToJumpMessage,
        messageProps: {
            ok: commonMessages.yes,
            close: commonMessages.close
        }
    };
    const { wizardData, wizardSnapshot, onPageJump } = wizardContext;

    onPageJump({
        wizardData,
        wizardSnapshot,
        modalMessages,
        index
    });
}

function renderSteps(
    translator,
    steps,
    currentStepIndex,
    stepsWithErrors,
    jumpTo,
    wizardContext,
    customMessageModal
) {
    return steps.map((step, index) => {
        const liClassName = classNames(styles.step, {
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: !step.visited
        });
        return (
            <ProgressPhase
            icon= {step.icon}
            id="phase_YourBusiness"
            title={translator(step.title)}
            onClick={() => {if (index !== currentStepIndex) {return jumpRenderModal(
                index,
                jumpTo,
                steps,
                step,
                wizardContext,
                customMessageModal
            )}}
            }

          >
            <ProgressStep
              active={step.visited}
              disabled={!step.visited}
              id="step_YourInformation"
              title={translator(step.title)}
              icon= {step.icon}
              visited={step.visited}
              withLabel={true}
              onClick={() => jumpRenderModal(
                  index,
                  jumpTo,
                  steps,
                  step,
                  wizardContext,
                  customMessageModal
              )
              }
            />
            </ProgressPhase>
        );
    });
}

function WizardSidebar(props) {
    const wizardContext = useContext(WizardContext);
    const translator = useContext(TranslatorContext);
    const {
        steps, currentStepIndex, jumpTo, stepsWithErrors, wizardTitle
    } = wizardContext;
    const { customMessageModal } = props;
    return (
        <ProgressIndicator
          id="ProgressIndicator"
          layout="phases"
        
          phone={{
            withLabel: true
          }}
          tablet={{
            withLabel: false
          }}
          withLabel={false}
        >
          {/* <ProgressPhase
            icon="mi-work"
            id="phase_YourBusiness"
            title="FNOL Widzet bar"
          > */}
          {renderSteps(

              translator,
              steps,
              currentStepIndex,
              stepsWithErrors,
              jumpTo,
              wizardContext,
              customMessageModal
          )}
         {/*  </ProgressPhase> */}
        </ProgressIndicator>
    );
}

WizardSidebar.propTypes = {
    customMessageModal: PropTypes.shape({})
};
WizardSidebar.defaultProps = {
    customMessageModal: {}
};
export default WizardSidebar;
